export default [
    {
        customer_id: 1,
        customer_name: "Noelia O'Kon",
        customer_email: "nelson@sas.com.my",
        customer_nric: "950405-13-4835",
        agent_email: "otho.smitham@example.com",
        agent_name: "Otho Elevin",
    },
];